import React from 'react';

import styled from '@emotion/styled';

import { COLORS, mq } from '@clutter/clean';

import { TransparentButton } from '@shared/transparent_button';

import { Arrow } from '@images/svg/arrow';

const NavButton = styled(TransparentButton)`
  width: 56px;
  height: 56px;
  margin: 28px;

  ${mq({
    display: ['none', 'block'],
  })}

  &:hover path {
    fill: ${COLORS.__primaryButtonHover};
  }
`;

const DIRECTIONS = {
  next: 'right',
  prev: 'left',
} as const;

const ARIA_LABELS = {
  next: 'next slide',
  prev: 'previous slide',
} as const;

export const CarouselNavButton: React.FC<{
  direction: 'next' | 'prev';
  onClick(): void;
}> = ({ direction, onClick }) => (
  <NavButton onClick={onClick} aria-label={ARIA_LABELS[direction]}>
    <Arrow direction={DIRECTIONS[direction]} />
  </NavButton>
);
